import { render, staticRenderFns } from "./AgentPay.vue?vue&type=template&id=2d7408cb&scoped=true&"
import script from "./AgentPay.vue?vue&type=script&lang=js&"
export * from "./AgentPay.vue?vue&type=script&lang=js&"
import style0 from "./AgentPay.vue?vue&type=style&index=0&id=2d7408cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7408cb",
  null
  
)

export default component.exports